import { Editor } from 'slate';

import type { OnKeyDown } from '@ui/MarkdownEditor/types';

import { isReusableContent } from './shared';

const enter: OnKeyDown = (event, editor) => {
  if (!(event.key === 'Enter' && !event.shiftKey)) {
    return;
  }

  const reusableContentEntry = Editor.above(editor, { match: isReusableContent });
  if (!reusableContentEntry || !editor.reusableContentEdit) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  editor.reusableContentEdit();
};

export default [enter];
